export const ALPHABET_LESSONS = {
  GET_TUTORIALS: "GET_TUTORIALS",
};
